module.exports = __webpack_public_path__ + "img/checked.a0148617.svg";